import React, { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/adventure_time.css';
import { getParsedRevision } from '../../lib/revisionUtils';
import './_styles.scss';

import { Dialog } from '../../../../../common/components/Dialog/Dialog';
import Button from '../../../../../common/components/Button/Button';
import EdgeComponentsList from '../../components/EdgeControllerComponentsList/EdgeControllerComponentsList';

const renderComponentsView = (revisionData) => (
  <div className="task-definition-section parsed-view">
    <h3>Components</h3>
    <EdgeComponentsList revision={revisionData} />
  </div>
);

const renderJsonView = (revisionJson) => {
  if (!revisionJson) return null;

  return (
    <div className="task-definition-section json-view">
      <h3>Full Revision JSON</h3>
      <div className="json-definition">
        <JSONPretty id="json-pretty" data={revisionJson} />
      </div>
    </div>
  );
};

const renderTaskInfo = (task) => (
  <div className="task-info-section">
    <h3>Task Information</h3>
    <div className="info-grid">
      <div className="info-item">
        <span className="info-label">Task ID:</span>
        <span className="info-value task-id">{task.taskId}</span>
      </div>
      <div className="info-item">
        <span className="info-label">Name:</span>
        <span className="info-value">{task.name}</span>
      </div>
      <div className="info-item">
        <span className="info-label">Type:</span>
        <span className="info-value">{task.type}</span>
      </div>
      <div className="info-item">
        <span className="info-label">Status:</span>
        <span className="info-value">{task.status}</span>
      </div>
      <div className="info-item">
        <span className="info-label">Execution Status:</span>
        <span className="info-value">{task.executionStatus}</span>
      </div>
      <div className="info-item">
        <span className="info-label">Created At:</span>
        <span className="info-value">
          {new Date(task.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
        </span>
      </div>
      <div className="info-item">
        <span className="info-label">Last Reported:</span>
        <span className="info-value">
          {new Date(task.lastReported).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
        </span>
      </div>
    </div>
  </div>
);

const TaskDetailsDialog = ({ open, onClose, task = null, revision = null, hideTaskInfo = false }) => {
  const [viewMode, setViewMode] = useState('parsed');

  if (!task && !revision) return null;

  const actions = [
    <Button key="close" onClick={onClose} color="secondary">
      Close
    </Button>,
  ];

  const revisionData = revision || null;
  const parsedRevision = getParsedRevision(revisionData);
  const jsonContent = JSON.stringify(parsedRevision, null, 2);
  const dialogTitle = task ? `Task Definition — ${task.taskId}` : 'Firmware Configuration Details';

  return (
    <Dialog open={open} onClose={onClose} title={dialogTitle} maxWidth="md" fullWidth actions={actions} className="task-details-dialog">
      <div className="task-definition-content">

        <div className="view-mode-tabs">
          <Tabs value={viewMode} onChange={(e, newValue) => setViewMode(newValue)} variant="standard">
            <Tab label="Parsed" value="parsed" />
            <Tab label="JSON" value="json" />
          </Tabs>
        </div>

        {viewMode === 'parsed' && <>{renderComponentsView(revisionData)}</>}

        {viewMode === 'json' && renderJsonView(jsonContent)}

        {!hideTaskInfo && task && renderTaskInfo(task)}
      </div>
    </Dialog>
  );
};

export default TaskDetailsDialog;
